import "@/directives";
import "@/libs/element";
import "@/permission";
import router from "@/router";
import store from "@/store";
import "default-passive-events";
import cookie from 'js-cookie';
import { UTable, UTableColumn } from "umy-ui";
import "umy-ui/lib/theme-chalk/index.css"; // 引入样式
import Vue from "vue";
import VueI18n from 'vue-i18n';
import Draggable from "vuedraggable";
import App from "./App";
import "./styles/umy-ui.reset.scss";

Vue.use(VueI18n);
Vue.prototype.cookie = cookie;
Vue.component("draggable", Draggable);
Vue.use(UTable);
Vue.use(UTableColumn);
// 设置 cookie 工具函数
Vue.prototype.set_cookie = (name, data, expires) => {
  cookie.set(name, data, {
    expires: expires
  })
}

const i18n = {
  locale: cookie.get('mfs_lang') || 'zh', // 语言标识,第一次登录默认是中文
  messages: {
    zh: require('./locales/zh-cn'), // 汉语
    en: require('./locales/en_us'), // 英语
  }
}

window.__VM__ = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");

api.users
    .getUserErpInfo({})
    .then(resolve => {
        console.log("获取erp");
        console.log(resolve);
        const userCode = resolve.data.userCode;
        //子午线埋点
        var jaq = [];
        window.jaq = jaq || [];
        jaq.push(["account", "JA2021_1823313"]); //站点编号
        jaq.push(["domain", "susf.jd.com"]); //站点域名
        jaq.push(["erp_account", userCode]);

        //ERP帐号，erp_account为字段名固定不变，test填入用户erp帐号(调用方自己传,若不传,会记录用户的京东pin)
        (function() {
            var ja = document.createElement("script");
            ja.type = "text/javascript";
            ja.async = true;
            ja.src = "//wl.jd.com/joya.js";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(ja, s);
        })();
    })
    .catch(reject => {
        console.log("getUserErpInfoData 请求失败", reject);
    });
